import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PublicService {

  constructor(
    private _http: HttpClient
  ) { }

  getVisaByCode(code:any):Observable<any>{
    return this._http.get<any>(`${environment.public}/GetVisaByHashCode/${code}`);
  }

  addVisaDocuments(code:any, payload:any):Observable<any>{
    return this._http.post<any>(`${environment.public}/addvisadocuments/${code}`, payload);
  }

  uploadVisaImage(payload:any, code:any):Observable<any>{
    return this._http.post<any>(`${environment.public}/UploadVisaImage/${code}`, payload);
  }
}
